import React from "react";
import PropTypes from "prop-types";
import ClipboardButton from "react-clipboard.js";
import { Link } from "react-router";
import styles from "components/upload-documents/alternative-upload-methods.scss";
import grid from "components/grid.scss";
import atIcon from "at-icon.png";
import cloudIcon from "cloud-icon.png";
import envelopeIcon from "envelope-icon.png";
import phoneIcon from "phone-icon.png";

export const AlternativeUploadMethods = ({ slug, onSetFlashMessage, submissionEmail }) => {
  const mobileText = `Send documents to Squirrel Street anytime,
    anywhere with our free mobile applications for iPhone, iPad and Android.`;
  const dropboxText = "Save time by simply dragging and dropping files into the Squirrel Street folder in Dropbox.";
  const envelopeText = `Fill one of our prepaid envelopes with your piles of paper clutter.
    We'll do the rest of the work for you!`;
  const emailText = `Forward emails from your online stores to Squirrel Street.
    We'll filter the documents and store everything online.`;

  return (
    <div>
      <h3 className={ styles["upload-title"] }>Alternative Upload Methods:</h3>
      <div className={ grid.row }>
        <div className={ `${grid["col-md-3"]} ${styles["upload-methods"]} upload4` }>
          <a
            className={ styles["upload-image-container"] }
            href="https://itunes.apple.com/au/app/squirrel-street-receipt-tracker/id1044924996?mt=8"
            rel="noopener noreferrer"
            target="_blank"
          >
            <img alt="Mobile" className={ styles["upload-image"] } src={ phoneIcon } />
            <div className={ styles.tooltip }>{mobileText}</div>
          </a>
          <div>Mobile</div>
        </div>
        <div className={ `${grid["col-md-3"]} ${styles["upload-methods"]} upload5` }>
          <Link className={ styles["upload-image-container"] } to={ `/accounts/${slug}/settings/integration` }>
            <img alt={ "Dropbox" } className={ styles["upload-image"] } src={ cloudIcon } />
            <div className={ styles.tooltip }>{dropboxText}</div>
          </Link>
          <div>Dropbox</div>
        </div>
        <div className={ `${grid["col-md-3"]} ${styles["upload-methods"]} upload6` }>
          <Link className={ styles["upload-image-container"] } to={ `/accounts/${slug}/manage-envelopes` }>
            <img alt={ "Magic Envelope" } className={ styles["upload-image"] } src={ envelopeIcon } />
            <div className={ styles.tooltip }>{envelopeText}</div>
          </Link>
          <div>Magic Envelope</div>
        </div>
        <div className={ `${grid["col-md-3"]} ${styles["upload-methods"]} upload7` }>
          <ClipboardButton
            className={ styles["upload-image-container"] }
            data-clipboard-text={ submissionEmail }
            onClick={ () => { onSetFlashMessage("Submission email address copied to clipboard"); } }
          >
            <img alt={ "Email" } className={ styles["upload-image"] } src={ atIcon } />
            <div className={ styles.tooltip }>{emailText}</div>
          </ClipboardButton>
          <div>Email</div>
        </div>
      </div>
    </div>
  );
};

AlternativeUploadMethods.propTypes = {
  onSetFlashMessage: PropTypes.func.isRequired,
  slug: PropTypes.string.isRequired,
  submissionEmail: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/upload-documents/alternative-upload-methods.jsx